<template>
  <v-list-group :sub-group="subGroup">
    <template v-slot:activator>
      <v-list-item-icon v-if="icon">
        <v-icon>{{ icon }}</v-icon>
      </v-list-item-icon>
      <v-list-item-content :class="!showBadge && !icon ? 'list-item-content' : ''">
        <v-badge v-if="showBadge" :inline="true" :left="true" :value="badgeValue" :content="badgeValue">
          <span class="badge-label">
            <v-list-item-title class="main-title">{{ translatedLabel | uppercase }}</v-list-item-title>
          </span>
        </v-badge>
        <span v-else>
          <v-list-item-title class="main-title">{{ translatedLabel | uppercase }}</v-list-item-title>
        </span>
      </v-list-item-content>
    </template>
    <slot></slot>
  </v-list-group>
</template>
<script>
  export default {
    name: 'OListGroupWrapper',
    props: {
      label: {
        type: String,
        default: '',
      },
      icon: {
        type: String,
        default: '',
      },
      badgeValue: {
        type: Number,
        default: 0,
      },
      showBadge: {
        type: Boolean,
        default: false,
      },
      subGroup: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      translatedLabel() {
        if (!this.$te(this.label)) {
          return this.label
        }
        return this.$t(this.label)
      },
    },
  }
</script>
<style scoped>
  /* Overwrite main title font size */
  .main-title {
    font-size: 0.8125rem !important; /* Ensure your custom style takes precedence */
  }

  .list-item-content {
    margin-left: 56px;
  }

  ::v-deep(.v-badge--inline .v-badge__wrapper) {
    min-width: 40px;
    margin: 0 4px 0 0;
  }

  ::v-deep(.badge-label) {
    padding: 0 24px 0 4px;
  }

  ::v-deep(.badge-label, .v-list-item--active .badge-label) {
    padding: 0 24px 0 4px;
  }

  ::v-deep(.v-list-item--active .badge-label) {
    padding: 0 24px 0 4px;
  }
</style>
